<template>
    <x-page title="Add Observer">
        <template #header-actions>
            <x-back-button :disabled="isLoading" />
        </template>
        <sms-observer-form
            id="sms-observer-form"
            @submit="handleSubmit"
            :disabled="isLoading"
            :errors="errors"
        />
        <template #footer>
            <x-submit-button
                form="sms-observer-form"
                :is-loading="isLoading"
                :disabled="isLoading"
            />
        </template>
    </x-page>
</template>

<script>
import XBackButton from "../../components/XBackButton.vue";
import XPage from "../../components/XPage.vue";
import XSubmitButton from "../../components/XSubmitButton.vue";
import { handleValidationXhrError } from "../../helpers";
import SmsObserverForm from "./SmsObserverForm.vue";

export default {
    components: {
        XPage,
        XBackButton,
        XSubmitButton,
        SmsObserverForm,
    },
    data() {
        return {
            errors: null,
            isLoading: false,
        };
    },
    methods: {
        handleSubmit(fields) {
            this.isLoading = true;
            const request = axios
                .post(`/api/sms-observers`, fields)
                .then(() => {
                    this.$notify({
                        type: "success",
                        title: `Berhasil`,
                        text: `${fields.label || "Observer"} added!`,
                    });
                    this.$router.back();
                });
            return handleValidationXhrError(request, (errors) => {
                this.errors = errors;
            }).finally(() => {
                this.isLoading = false;
            });
        },
    },
};
</script>
